/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import PremiumLockIcon from 'bundles/audit/components/PremiumLockIcon';
import { useAuditUpgradeFlowData } from 'bundles/audit/contexts/AuditUpgradeFlowDataContext';

type Props = {
  defaultIcon: JSX.Element | null;
  size: number;
  title?: string;
};

const GradedPremiumIcon = (props: Props) => {
  const { defaultIcon, size, title = '' } = props;
  const auditUpgradeFlowContextData = useAuditUpgradeFlowData();
  const isAuditFlow = auditUpgradeFlowContextData !== null;

  return !isAuditFlow ? defaultIcon : <PremiumLockIcon size={size} title={title} />;
};
export default GradedPremiumIcon;
